import styled from 'styled-components'
import { ModalTypes } from '@/types'
import { Dialog } from '@headlessui/react'

interface ModalWrapperProps {
  type?: ModalTypes
  width?: string
  maxwidth?: string
  height?: string
}

export const ModalWrapper = styled(Dialog.Panel)<ModalWrapperProps>`
  background-color: white;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  position: fixed;
  top: 8%;
  left: 50%;
  transform: translateX(-50%);
  width: ${(props) => (props.width ? props.width : '300px')};
  max-width: ${(props) => (props.maxwidth ? props.maxwidth : '100%')};
  height: ${(props) => (props.height ? props.height : 'auto')};
  overflow: hidden;

  @media (max-width: 1024px) {
    top: 11%;
    width: ${(props) => (props.width ? props.width : '300px')};
    height: ${(props) => (props.height ? props.height : 'auto')};
  }

  ${(props) =>
    props.type === 'search' &&
    `
    @media (min-width: 601px) {
      box-shadow: 0 2px 5px 0 rgba(0,0,0,0.25);
      left: auto;
      transform: none;
      position: absolute;
    }
    @media (min-width: 1025px) {
      top: -50px;
      right: 65px;
    }
    @media (min-width: 768px) and (max-width: 1024px) {
      width: 90%;
      top: -50px;
      right: 65px;
    }
    @media (min-width: 601px) and (max-width: 768px) {
      width: 90%;
      top: -58px;
      right: 45px;
    }
  `}

  @media (max-width: 600px) {
    width: 90%;
    height: ${(props) => (props.height ? props.height : 'auto')};

    &.fullscreen-mobile {
      width: 100%;
      height: 100%;
      top: 0;
      border-radius: 0;
    }
  }
`

export const ModalContentWrapper = styled.div`
  display: flex;
  margin-bottom: auto;
  height: 100%;
  flex-direction: column;
  overflow: auto;
  box-sizing: border-box;
`
export const ModalContainer = styled.div`
  padding: 40px;
  width: 50%;
  box-sizing: border-box;
  border-right: 1px solid var(--grey-25);
  height: max-content;

  @media (max-width: 768px) {
    padding: 40px 20px;
    width: 100%;
  }
`
// TODO: Topbar Z Index
export const ModalBackdrop = styled(Dialog.Overlay)<{ type: ModalTypes }>`
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;

  ${(props) =>
    props.type === 'search' &&
    `
    @media (min-width: 601px) {
      background-color: transparent;
      backdrop-filter: blur(5px);
      top: 80px;
    }
    
    @media (min-width: 601px) and (max-width: 768px) {
      top: 68px;
    }
  `}
`

export const ModalTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${({ theme }) => theme.colourPalette?.primaryColour || 'var(--brand-secondary)'};
  height: 70px;
  color: white;
  padding: 0 24px;
  font-weight: var(--font-medium);
  font-size: 16px;

  svg {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    fill: white;
    cursor: pointer;
  }

  @media (max-width: 600px) {
    height: 54px;
  }
`

export const ModalDescription = styled(Dialog.Description)`
  font-size: 16px;
  font-weight: var(--font-regular);
  line-height: 1.8;

  strong {
    font-weight: var(--font-medium);
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const ModalItem = styled.div`
  padding: 35px 24px;
  border: 1px solid var(--grey-25);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
`
export const ModalItemTitle = styled.span`
  display: block;
  font-weight: var(--font-bold);
  line-height: 1.4;
  margin-bottom: 25px;
  font-size: 16px;
`

export const InputField = styled.div`
  display: flex;
  flex-direction: column;

  textarea {
    height: 150px;
    resize: none;
  }
`
export const ProductTileWrapper = styled.div`
  display: block;

  @media (max-width: 768px) {
    margin-top: -24px;
    width: 100vw;
    left: -24px;
    position: relative;
    margin-bottom: 20px;
  }
`
